import React from 'react';
import './styles.css';

const Dialog = ({ dialogStyles = null, dialogCssClass = '', children }) => {
  return (
    <div className={'dialog ' + dialogCssClass} style={dialogStyles}>
      {children}
    </div>
  );
};

export default Dialog;
